<template>
  <div
    v-if="visibility"
    class="tertiary--text timer"
    :style="{ marginLeft: appMargin }"
  >
    <BlackBtn
      blue
      style="padding: 6px 0px !important;"
      @click="refreshData"
    >
      <v-icon
        small
        :class="{loading}"
      >
        mdi-refresh
      </v-icon>
      <span class="body-1">
        更新
      </span>
    </BlackBtn>

    <div
      class="d-flex align-center mt-1 ml-3"
    >
      <v-icon
        color="tertiary"
        style="font-size: 20px;"
      >
        mdi-clock-outline
      </v-icon>
      <span
        class="body-1 ml-1"
        style="width: 170px;"
      >
        {{ updatedAt }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BlackBtn } from '@/components/ui'
const targetRoutes = ['dashboard', 'list', 'customers']

export default {
  name: 'DataTimer',
  components: {
    BlackBtn
  },
  computed: {
    ...mapGetters('display', ['appMargin']),
    route () {
      return this.$route.path.substring(1)
    },
    visibility () {
      return targetRoutes.some(r => r === this.route)
    },

    loading () {
      return this.$store.state[this.route].loading
    },

    timeDiff () {
      return this.$store.getters[`${this.route}/timeDiff`]
    },

    updatedAt () {
      if (this.timeDiff === -2) return 'データ未取得'

      if (this.timeDiff === -1) return 'データ取得中...'

      if (this.timeDiff === 0) return 'データ取得：たった今'

      if (this.timeDiff < 60) return `データ取得：${this.timeDiff}分前`

      const hours = Math.floor(this.timeDiff / 60)
      if (hours < 24) return `データ取得：${hours}時間前`

      const days = Math.floor(hours / 24)
      const extraHours = hours % 24
      return `データ取得：${days}日${extraHours}時間前`
    }
  },
  methods: {
    async refreshData () {
      switch (this.route) {
        case 'dashboard':
          await this.$store.dispatch('dashboard/initDashboardData')
          break
        case 'list':
          await this.$store.dispatch('list/setCustomers')
          break
        case 'customers':
          await this.$store.dispatch('customers/search')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.timer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.loading {
  animation: rotate 1.8s linear infinite;
}
@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
